import { render } from "./RestaurantScore.vue?vue&type=template&id=0efcb55c&scoped=true&ts=true"
import script from "./RestaurantScore.vue?vue&type=script&lang=ts"
export * from "./RestaurantScore.vue?vue&type=script&lang=ts"

import "./RestaurantScore.vue?vue&type=style&index=0&id=0efcb55c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efcb55c"]])

export default __exports__